var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[(_vm.legendURL)?_c('img',{staticClass:"legendImage",attrs:{"src":_vm.legendURL}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }